import { useRef } from "react";
import { Link } from "react-router-dom";
import MonoLegend from "./MonoLegend";
import { useReveal } from "@/hooks/useReveal";

function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export default function Footer() {
  const year = new Date().getFullYear();
  const footerRef = useRef(null);
  useReveal(footerRef);

  return (
    <footer
      ref={footerRef}
      className="relative z-10 border-t border-hairline bg-panel/50 px-5 py-14 md:px-8"
      data-testid="site-footer"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 md:flex-row md:items-center">
        <div>
          <button
            data-anim
            onClick={() => scrollToId("top")}
            data-testid="footer-wordmark"
            className="flex items-center gap-2.5 font-serif text-2xl tracking-tight text-ink"
          >
            <img
              src="/logo-icon.png"
              alt="Zigler Designs owl mark"
              className="h-12 w-12 object-contain"
            />
            <span>
              <span className="text-pine">Zigler</span> Designs
            </span>
          </button>
          <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.16em] text-ink-dim">
            Veteran-owned · One build a month, on purpose
          </p>
          <p className="mt-1.5 font-mono text-[11px] uppercase tracking-[0.16em] text-ink-dim">
            Serving Colorado Springs, Denver &amp; the Front Range
          </p>
        </div>

        <div data-anim data-anim-delay="0.1" className="flex flex-col items-start gap-3 md:items-end">
          <MonoLegend>Peyton, CO · 6,800 FT</MonoLegend>
          <Link
            to="/galleries"
            data-testid="footer-galleries-link"
            className="font-mono text-[11px] uppercase tracking-[0.16em] text-ink-dim transition-colors hover:text-pine"
          >
            Galleries (review) →
          </Link>
          <button
            onClick={() => scrollToId("top")}
            data-testid="footer-back-to-top"
            className="font-mono text-[11px] uppercase tracking-[0.16em] text-ink transition-colors hover:text-pine"
          >
            Back to top ↑
          </button>
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-7xl border-t border-hairline pt-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-ink-dim">
          © {year} Zigler Designs. All rights reserved. Built at elevation.
        </p>
        <p className="mt-2 max-w-2xl text-[11px] normal-case leading-relaxed tracking-normal text-ink-dim/80">
          This site uses analytics, including session recording, to understand how visitors use it
          and improve the experience. No data is sold to third parties.
        </p>
      </div>
    </footer>
  );
}
